import { StrictMode } from "react";

import { LazyHotReloadIndicator } from "@shared/components/LazyHotReloadIndicator/LazyHotReloadIndicator";
import { LazyReactAxe } from "@shared/components/LazyReactAxe/LazyReactAxe";
import { Router } from "@shared/components/Router/Router";
import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary } from "@unauthenticated/signupSignin/components/ErrorBoundary/ErrorBoundary";
import { Providers } from "@unauthenticated/signupSignin/components/Providers/Providers";

import { JourneyCheckoutPage } from "./JourneyCheckoutPage";

interface Props {
  storeAttributes: {
    storeName: string;
    storeSlug: string;
    storeLogo?: string;
  };
  flippers: Flipper[];
  patientId?: string;
  storeId: string;
  ssoErrors?: string;
  analyticsAnonymousId: string;
  journeyPackageId: string;
}

const JourneyCheckoutEntryPoint = ({
  storeAttributes: storeAttributesUnused,
  flippers,
  patientId,
  storeId,
  journeyPackageId,
  analyticsAnonymousId,
}: Props) => {
  return (
    <StrictMode>
      <Router>
        <Providers
          currentCountry="US" // Default for now
          flippers={flippers}
          e2e={false} // Default for now
          analyticsAnonymousId={analyticsAnonymousId}
        >
          <ErrorBoundary {...{ flippers, roleId: patientId, storeId }}>
            <JourneyCheckoutPage journeyPackageId={journeyPackageId} storeId={storeId} />
          </ErrorBoundary>
        </Providers>
        <LazyHotReloadIndicator />
        <LazyReactAxe />
      </Router>
    </StrictMode>
  );
};

export { JourneyCheckoutEntryPoint };
